"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ToggleSwitch = void 0;

var _react = _interopRequireDefault(require("react"));

var _core = require("@material-ui/core");

var _colors = require("../../theme/colors");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var useStyles = (0, _core.makeStyles)(function () {
  return {
    root: {
      width: function width(props) {
        return props.small ? '2.5rem' : '5rem';
      },
      height: function height(props) {
        return props.small ? '1.5rem' : '2.75rem';
      },
      padding: 0,
      display: 'flex'
    },
    switchBase: {
      padding: function padding(props) {
        return props.small ? '0.25rem' : '0.375rem';
      },
      color: _colors.colors.primaryBlue,
      '&$checked': {
        transform: function transform(props) {
          return props.small ? 'translateX(1rem)' : 'translateX(2.25rem)';
        },
        '& + $track': {
          opacity: 1,
          backgroundColor: _colors.colors.primaryGreen
        },
        '&$focusVisible $thumb': {
          backgroundColor: 'transparent'
        }
      },
      '&&:hover': {
        backgroundColor: 'transparent'
      }
    },
    thumb: {
      width: function width(props) {
        return props.small ? '1rem' : '2rem';
      },
      height: function height(props) {
        return props.small ? '1rem' : '2rem';
      },
      boxShadow: 'none'
    },
    track: {
      borderRadius: '1.375rem',
      opacity: 1,
      backgroundColor: _colors.colors.spaceGrey
    },
    checked: {
      transform: function transform(props) {
        return props.small ? 'translateX(1rem)' : 'translateX(2.25rem)';
      }
    },
    focusVisible: {
      backgroundColor: 'transparent'
    },
    label: {
      fontFamily: 'Novozymes, Arial',
      fontSize: function fontSize(props) {
        return props.small ? '0.75rem' : '1rem';
      },
      margin: function margin(props) {
        return props.small ? '0.25rem' : '0.5rem';
      }
    },
    wrapper: {
      display: 'flex',
      alignItems: 'center',
      flexDirection: function flexDirection(props) {
        return props.labelPosition === 'up' || props.labelPosition === 'down' ? 'column' : 'row';
      }
    },
    disabledSwitch: {
      '&$checked': {
        '& + $track': {
          opacity: 1,
          backgroundColor: _colors.colors.grey
        }
      }
    }
  };
});

var ToggleSwitch = function ToggleSwitch(props) {
  var classes = useStyles(props);
  return /*#__PURE__*/_react["default"].createElement(_core.Box, {
    className: classes.wrapper
  }, props.label && (props.labelPosition === 'up' || props.labelPosition === 'left') ? /*#__PURE__*/_react["default"].createElement(_core.Box, {
    className: classes.label
  }, props.label) : null, /*#__PURE__*/_react["default"].createElement(_core.Switch, _extends({
    focusVisibleClassName: classes.focusVisible,
    disableRipple: true,
    disabled: props.disabled,
    classes: {
      root: classes.root,
      switchBase: classes.switchBase,
      thumb: classes.thumb,
      track: classes.track,
      checked: classes.checked,
      disabled: classes.disabledSwitch
    }
  }, props)), props.label && (props.labelPosition === 'down' || props.labelPosition === 'right') ? /*#__PURE__*/_react["default"].createElement(_core.Box, {
    className: classes.label
  }, props.label) : null);
};

exports.ToggleSwitch = ToggleSwitch;
ToggleSwitch.defaultProps = {
  labelPosition: 'left'
};